const experienceList = [
    {
        title: 'Desenvolvedor Freelancer',
        start: 'Maio/2020',
        end: 'atualmente',
        description: 'Desenvolvimento de páginas e aplicações com foco em web, responsividade, UI e UX, tendo o JavaScript (e suas stacks) como principal linguagem utilizada nos projetos.',
    },
    {
        title: 'Designer Freelancer',
        start: 'Agosto/2016',
        end: 'atualmente',
        description: 'Designer gráfico autodidata, criador de marca, identidade visual, entre outras demandas, com alguns bons trabalhos executados, incluindo o primeiro mapa da Moovit de transporte metropolitano do Rio de Janeiro, que rendeu uma matéria no Jornal O Dia, na época.',
    }
]

export default experienceList;